import { useLayoutEffect, useState, type DependencyList, type RefObject } from 'react'

export const useIsElementTruncated = <T extends HTMLElement>(
  elementRef: RefObject<T | null>,
  deps: DependencyList
): boolean => {
  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    const el = elementRef.current
    if (!el) return
    setIsTruncated(el.scrollWidth > el.clientWidth)
  }, deps)

  return isTruncated
}
